import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/appConfig';
import { toast } from "react-toastify";
import * as serverRoutes from 'utils/consts/serverRoutes.js';

//Synchronous

//Asynchronous
export const getAppConfig = (callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstance.get(serverRoutes.AppConfig.crud())
      .then((response) => {
        dispatch({
          type: Types.GET_APP_CONFIG,
          payload: response.data
        });
        callback?.(response.data);
      })
      .catch((err) => {
        console.log(err)
        callback?.();
      })
  }
}

export const updateAppConfig = (configId, configData) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING_UPDATE
    });
    axiosInstance.put(serverRoutes.AppConfig.crud(`/${configId}`), configData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_APP_CONFIG,
          payload: response.data
        });
        toast.success("Atualizado com sucesso!", { autoClose: 10000 });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Houve um erro ao atualizar.", { autoClose: 10000 });
      })
  }
}
